// extracted by mini-css-extract-plugin
export default {"container":"errorFallback_container__O1ukc","error":"errorFallback_error__iueKN","back":"errorFallback_back__ZoEFb"};